import {
	type PPPDatesByType,
	PPPTypeTabs,
	type PPPStatusTab,
	type PPPTypeTab,
} from './types/tabs/tabs.types';
import type { PPPLocaleReturnType } from '../usePPPLocale';
import type { ModalStringsReturnType } from './types/utils/resolveModalStrings.types';
import type { NahledyudajuPppPppSubjektShrnutiDto } from '@gov-nx/api';
import { nameFormatting } from 'libs/utils/common/src/String/personInformation';
import type { PPPSeznamFilterType } from './types/filter/seznamFilter.types';
import { ALLOWED_STATUS_BY_TYPE, FALLBACK_STATUS_BY_TYPE } from './constants';

export const resolveActiveTabValue = <T extends string>(
	value: string | undefined,
	isValid: (value: string) => value is T,
	fallback: T
): T => {
	if (!value) {
		return fallback;
	}

	return isValid(value) ? value : fallback;
};

export const resolveModalFormStrings = (
	activeTypeTab: PPPTypeTab,
	t: PPPLocaleReturnType['t']
): ModalStringsReturnType => {
	switch (activeTypeTab) {
		case PPPTypeTabs.AKTUALNI:
			return {
				label: t('seznam.sluzby.formular.modal.label.aktualni'),
				description: t('seznam.sluzby.formular.modal.description.aktualni'),
			};
		case PPPTypeTabs.HISTORIE:
			return {
				label: t('seznam.sluzby.formular.modal.label.historie'),
				description: t('seznam.sluzby.formular.modal.description.historie'),
			};
		default:
			return { label: '', description: '' };
	}
};

export const resolveStatusForType = (
	type: PPPTypeTab,
	status: PPPStatusTab
): PPPStatusTab => {
	const isStatusInAllowed = ALLOWED_STATUS_BY_TYPE[type].includes(status);

	return isStatusInAllowed ? status : FALLBACK_STATUS_BY_TYPE[type];
};

export const resolveSubjectName = (
	subject: NahledyudajuPppPppSubjektShrnutiDto | undefined
) => {
	if (!subject?.nazev) {
		return undefined;
	}

	if (subject.typ === 'FO') {
		return nameFormatting(subject.nazev);
	}

	return subject.nazev;
};

export const resolveDatesForType = (
	nextType: PPPTypeTab,
	datesByTypeFilter: PPPDatesByType
): Pick<PPPSeznamFilterType, 'datumOd' | 'datumDo'> => ({
	datumOd: datesByTypeFilter[nextType].datumOd,
	datumDo: datesByTypeFilter[nextType].datumDo,
});
